// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"id":"play","fill":"props.strokeColor1","d":"M18.25 11.9998L8.5 17.6289L8.5 6.37061L18.25 11.9998Z"}}]};

const PlayIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'play',
    ref,
    icon: element,
  },
));

PlayIcon.displayName = 'PlayIcon';

export default PlayIcon;
